module.exports = __webpack_public_path__ + "static/media/03.fe1f99f0.jpg";